<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-02-27 10:53:03
-->
<template>
  <!-- 养成 -->
  <div class="content-wrap">
    <!-- 育苗 -->
    <div
      class="container-ym"
      style="width: 100%"
    >
      <!-- 内容盒子 -->
      <OverviewTab>
        <div class="content-box">
          <!-- 左边盒子 -->
          <div class="left-box">
            <!-- 上 -->
            <div class="top-box">
              <el-carousel
                :interval="10000"
                height="136px"
                indicator-position="none"
                arrow="always"
              >
                <el-carousel-item
                  v-for="item in carouselData"
                  :key="item.periodName"
                >
                  <!-- 一造次销售产值/万元 -->
                  <div>
                    <div>
                      <div class="text">
                        <p>
                          <img
                            src="../../../../assets/img/middle/销售产值.png"
                            alt=""
                          />
                        </p>
                        <p>
                          <CountIn
                            :startVal="0"
                            :endVal="item.saleMoney"
                            :speed="1"
                            :decimals="2"
                            :isReverse="item.saleMoney >= 0 ? false : true"
                            :noAnimation="false"
                          />
                        </p>
                        <p :title="`${item.periodName}销售产值/万元`">
                          {{ item.periodName }}销售产值/万元
                        </p>
                      </div>
                      <div class="num-text">
                        <div>
                          <p>环比&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                          <p>
                            <span>{{ item.saleMoneyPerCent }}%</span>
                            <span>
                              <img
                                v-if="item.saleMoneyPerCent > 0"
                                src="../../../../assets/img/middle/上.png"
                                alt=""
                              />
                              <img
                                v-if="item.saleMoneyPerCent < 0"
                                src="../../../../assets/img/middle/下.png"
                                alt=""
                              />
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </p>
                        </div>
                        <div>
                          <p>上一造次</p>
                          <p>
                            <span>{{ item.saleMoneyLast }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 一造次收获总产量(万斤) -->
                  <div>
                    <div>
                      <div class="text">
                        <p>
                          <img
                            src="../../../../assets/img/middle/收货总产量.png"
                            alt=""
                          />
                        </p>
                        <p>
                          <CountIn
                            :startVal="0"
                            :endVal="item.harvestYield"
                            :speed="1"
                            :decimals="2"
                            :isReverse="item.harvestYield >= 0 ? false : true"
                            :noAnimation="false"
                          />
                        </p>
                        <p :title="`${item.periodName}收获总产量(万斤)`">
                          {{ item.periodName }}收获总产量(万斤)
                        </p>
                      </div>
                      <div class="num-text">
                        <div>
                          <p>环比&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                          <p>
                            <span>{{ item.harvestYieldPerCent }}%</span>
                            <span>
                              <img
                                v-if="item.harvestYieldPerCent > 0"
                                src="../../../../assets/img/middle/上.png"
                                alt=""
                              />
                              <img
                                v-if="item.harvestYieldPerCent < 0"
                                src="../../../../assets/img/middle/下.png"
                                alt=""
                              />
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </p>
                        </div>
                        <div>
                          <p>上一造次</p>
                          <p>
                            <span>{{ item.harvestYieldLast }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 一造次收获总面积(亩) -->
                  <div>
                    <div>
                      <div class="text">
                        <p>
                          <img
                            src="../../../../assets/img/middle/收货总产值.png"
                            alt=""
                          />
                        </p>
                        <p>
                          <CountIn
                            :startVal="0"
                            :endVal="item.harvestArea"
                            :speed="1"
                            :decimals="2"
                            :isReverse="item.harvestArea >= 0 ? false : true"
                            :noAnimation="false"
                          />
                        </p>
                        <p :title="`${item.periodName}收获总面积(亩)`">
                          {{ item.periodName }}收获总面积(亩)
                        </p>
                      </div>
                      <div class="num-text">
                        <div>
                          <p>环比&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                          <p>
                            <span>{{ item.harvestAreaPerCent }}%</span>
                            <span>
                              <img
                                v-if="item.harvestAreaPerCent > 0"
                                src="../../../../assets/img/middle/上.png"
                                alt=""
                              />
                              <img
                                v-if="item.harvestAreaPerCent < 0"
                                src="../../../../assets/img/middle/下.png"
                                alt=""
                              />
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </p>
                        </div>
                        <div>
                          <p>上一造次</p>
                          <p>
                            <span>{{ item.harvestAreaLast }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <!-- 中 -->
            <div class="center-box">
              <!-- 一造次各造次销售产值图表 -->
              <div style="position: relative">
                <div>
                  <span></span>
                  <span>各造次销售产值(万元)</span>
                </div>
                <div
                  v-show="isDown"
                  class="down-box"
                >
                  {{ OneCakeChartData.other ? "收起" : "更多" }}
                </div>
                <!-- 产值charts -->
                <div
                  id="outputValueCharts"
                  style="padding-top: 20px; width: 100%; height: 100%"
                  ref="outputValueCharts"
                ></div>
                <div
                  v-if="OneCakeChartData.other"
                  class="other"
                >
                  <div
                    v-for="(item, idx) of OneCakeChartData.otherData"
                    :key="idx"
                  >
                    {{ item.name }}:{{ item.value }}
                  </div>
                </div>
              </div>
              <!-- 一造次各造次收获产量图表 -->
              <div style="position: relative">
                <div>
                  <span></span>
                  <span>各造次收获产量(万斤)</span>
                </div>
                <div
                  v-show="isDown"
                  class="down-box"
                >
                  {{ TwoCakeChartData.other ? "收起" : "更多" }}
                </div>
                <!-- 产量charts -->
                <div
                  id="outputAmountCharts"
                  style="padding-top: 20px; width: 100%; height: 100%"
                  ref="outputAmountCharts"
                ></div>
                <div
                  v-if="TwoCakeChartData.other"
                  class="other"
                >
                  <div
                    v-for="(item, idx) of TwoCakeChartData.otherData"
                    :key="idx"
                  >
                    {{ item.name }}:{{ item.value }}
                  </div>
                </div>
              </div>
              <!-- 一造次各造次收获面积图表 -->
              <div style="position: relative">
                <div>
                  <span></span>
                  <span>各造次收获面积(亩)</span>
                </div>
                <div
                  v-show="isDown"
                  class="down-box"
                >
                  {{ ThreeCakeChartData.other ? "收起" : "更多" }}
                </div>
                <!-- charts -->
                <div
                  id="areaCharts"
                  style="padding-top: 20px; width: 100%; height: 100%"
                  ref="areaCharts"
                ></div>
                <div
                  v-if="ThreeCakeChartData.other"
                  class="other"
                >
                  <div
                    v-for="(item, idx) of ThreeCakeChartData.otherData"
                    :key="idx"
                  >
                    {{ item.name }}:{{ item.value }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 下 -->
            <div class="bottom-box">
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('tangkouCharts')">各造次收获塘口数</span>
                </div>
                <!-- charts -->
                <div
                  id="tangkouCharts"
                  ref="tangkouCharts"
                ></div>
              </div>
              <div class="bottom-center-box">
                <div>
                  <span></span>
                  <span @click="isShowChartClick('rashDateCostCharts')">各造次养殖天数与投入成本</span>
                  <span
                    class="check"
                    style="display: block; width: 85px"
                  >
                    <RouteTarget :pathName="'day-yc-cost-details'">
                      <span class="check">查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
                    </RouteTarget>
                  </span>
                </div>
                <!-- 一造次各造次育苗天数与投入成本图表charts -->
                <div
                  id="dateCostCharts"
                  style="padding-top: 20px; width: 100%; height: 100%"
                  ref="rashDateCostCharts"
                ></div>
                <MySlider
                  style="bottom: 45px"
                  :total="dateCostChartsData.xData.length"
                  @change="getStartValue($event)"
                ></MySlider>
              </div>
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('table-one-box')">各造次投苗情况</span>
                </div>
                <!-- table -->
                <span class="table-box">
                  <p
                    class="table-one-box"
                    @mouseover="clearBreedScroll()"
                    @mouseleave="setBreedScroll()"
                  >
                    <el-table
                      :header-cell-style="{
                        background: '#1E1E2B',
                        color: '#FFFFFF',
                        borderColor: '#46494a',
                      }"
                      height="320px"
                      :data="tableOneData"
                      ref="breedTable"
                    >
                      <el-table-column
                        prop="periodName"
                        label="养殖造次"
                      ></el-table-column>
                      <el-table-column
                        prop="breedName"
                        label="品种名称"
                      ></el-table-column>
                      <el-table-column
                        prop="putNumber"
                        label="投苗量/万"
                      ></el-table-column>
                      <el-table-column
                        prop="putBoxNum"
                        label="投苗塘口数/口"
                      ></el-table-column>
                      <el-table-column
                        prop="putBoxArea"
                        label="投苗面积/亩"
                      ></el-table-column>
                    </el-table>
                  </p>
                </span>
              </div>
            </div>
          </div>
          <!-- 右边盒子 -->
          <div class="right-box">
            <!-- 上 -->
            <div class="top-box">
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('DailyFeedCharts')">饲料日投喂 (今日总量：{{ DailyFeedNum }}{{fodderKgToJin}})</span>
                </div>
                <!-- 动保日投用charts -->
                <!-- <div
                  id="DailyFeedCharts"
                  ref="DailyFeedCharts"
                ></div> -->
                <div
                  id="DailyFeedCharts"
                  ref="DailyFeedCharts"
                  style="height: 100%; padding-top: 20px"
                ></div>
              </div>
              <div>
                <div style="margin-bottom: 6px">
                  <span></span>
                  <span>各造次饲料使用情况(总量：{{ feedUseNum }}{{fodderKgToJin}})</span>
                </div>
                <!-- table -->
                <div
                  class="table-content"
                  ref="tableContent"
                >
                  <span
                    class="table-box"
                    @mouseover="clearScrollFeed()"
                    @mouseleave="setScrollFeed()"
                  >
                    <p class="table-two-box">
                      <el-table
                        :header-cell-style="{
                          background: '#1E1E2B',
                          color: '#FFFFFF',
                          borderColor: '#46494a',
                          textAlign: 'left',
                        }"
                        :data="tableTwoData.OneTableData"
                      >
                        <el-table-column
                          prop="periodName"
                          label="养殖造次"
                        ></el-table-column>
                        <el-table-column
                          prop="fodderType"
                          label="饲料品类"
                        ></el-table-column>
                        <el-table-column
                          prop="fodderWeight"
                          label="总投料量"
                        ></el-table-column>
                      </el-table>
                    </p>
                    <p class="table-two-box">
                      <el-table
                        :header-cell-style="{
                          background: '#1E1E2B',
                          color: '#FFFFFF',
                          borderColor: '#46494a',
                        }"
                        :data="tableTwoData.TwoTableData"
                      >
                        <el-table-column
                          prop="periodName"
                          label="养殖造次"
                        ></el-table-column>
                        <el-table-column
                          prop="breedName"
                          label="养殖品种"
                        ></el-table-column>
                        <el-table-column
                          prop="fodderWeight"
                          label="总投料量"
                        ></el-table-column>
                      </el-table>
                    </p>
                  </span>
                </div>
              </div>
            </div>
            <!-- 中 -->
            <div class="center-box">
              <div>
                <div>
                  <span></span>
                  <span
                    style="color: white"
                    @click="isShowChartClick('PrivateChatCharts')"
                  >动保日投用 (今日总金额：{{ DailyBasisNum }}万元)</span>
                </div>
                <!-- table -->
                <div
                  id="PrivateChatCharts"
                  ref="PrivateChatCharts"
                ></div>
              </div>
              <div>
                <div>
                  <span></span>
                  <span
                    @click="ChartsCheckoutTarget(1)"
                    :class="[feedAndDongbaoTarget == 1 ? 'success' : '']"
                    style="cursor: pointer"
                  >饲料现存量
                  </span>
                  <span>|</span>
                  <span
                    @click="ChartsCheckoutTarget(2)"
                    :class="[feedAndDongbaoTarget == 2 ? 'success' : '']"
                    style="cursor: pointer"
                  >
                    动保现存量</span>
                  <span class="check">
                    <RouteTarget :pathName="feedAndMoveRouter">
                      <span class="check">查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
                    </RouteTarget>
                  </span>
                </div>
                <!-- 饲料日投喂charts -->
                <div
                  id="PrivateChatExistingCharts"
                  ref="PrivateChatExistingCharts"
                ></div>
              </div>
            </div>
            <!-- 下 -->
            <div class="bottom-box">
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('dayDynamicProtectionCharts')">日死鱼情况 (今日总量：{{ DeadFishNum }}尾)</span>
                </div>
                <!-- 动保日投用charts -->
                <div
                  id="dayDynamicProtectionCharts"
                  ref="dayDynamicProtectionCharts"
                ></div>
              </div>
              <div>
                <div>
                  <span></span>
                  <span>各区域各品种死鱼情况</span>
                  <span class="swiper-warning-box">
                    <ul
                      class="waring-ul"
                      ref="warningbox"
                    >
                      <li
                        :key="index"
                        v-for="(item, index) in DeadfishChartData.warningData"
                        class="waring-li"
                      >
                        <i class="i1">[预警]</i>
                        <i class="i2">{{ item }}</i>
                      </li>
                    </ul>
                  </span>
                </div>
                <!-- 各区域各品种死鱼情况charts -->
                <div
                  id="SaveDynamicProtectionCharts"
                  ref="SaveDynamicProtectionCharts"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <el-dialog
          width="80%"
          @close="isShowChartClose"
          class="show-chart-box"
          :visible.sync="isShowChart"
        >
          <span class="show-chart-title">{{ showChart.title }}</span>
          <div class="type_btn_container">
            <span
              @click="isShowChartTypeClick(showChart.chartType, item.id)"
              v-bind:class="{
                'sub-active': showChart.searchType == item.id,
              }"
              :key="index"
              v-for="(item, index) in showChart.targetCategory"
            >
              {{ item.name }}
            </span>
          </div>
          <div
            class="cancel-delete"
            @click="isShowChart = false"
          ></div>
          <div
            class="chart-content"
            v-if="!isShowTable"
            ref="chart_vm"
            id="chart_vm"
          ></div>
          <span
            class="show-chart-table-box"
            v-else-if="isShowTable"
          >
            <p class="table-one-box">
              <el-table
                :header-cell-style="{
                  background: 'rgba(15,14,25)',
                  color: '#FFFFFF',
                  borderColor: '#46494a',
                }"
                :data="tableOneData"
                ref="breedTable"
              >
                <el-table-column
                  prop="periodName"
                  label="养殖造次"
                ></el-table-column>
                <el-table-column
                  prop="breedName"
                  label="品种名称"
                ></el-table-column>
                <el-table-column
                  prop="putNumber"
                  label="投苗量/万"
                ></el-table-column>
                <el-table-column
                  prop="putBoxNum"
                  label="投苗塘口数/口"
                ></el-table-column>
                <el-table-column
                  prop="putBoxArea"
                  label="投苗面积/亩"
                ></el-table-column>
              </el-table>
            </p>
          </span>
        </el-dialog>
      </OverviewTab>
    </div>
  </div>
</template>

<script>
import * as $echarts from "echarts";
import Page from "@/utils/methods/page";
import service from "../../../../api/middle/day/yc-service";
import OverviewTab from "@/components/pc/overview-tab.vue";
import RouteTarget from "@/components/pc/route-target.vue";
import CountIn from "@/components/pc/count-in.vue";
import debounce from "@/utils/debounce";
import BaiduCustomeMap from "@/components/pc/baidu-map/baidu-custome-map.vue";
import MySlider from "@/components/pc/my-slider.vue";
import { listParamStatus } from "@/api/general.js";
export default {
  name: "ym",
  inject: ["app"],
  components: {
    OverviewTab,
    RouteTarget,
    CountIn,
    BaiduCustomeMap,
    MySlider,
  },
  props: {
    date: "",
    dateType: "",
  },
  data() {
    return {
      // 放大查看table表格
      isShowTable: false,
      // 判断饲料现存量和动保现存量的存储对象
      feedDefaultNum: null,
      // 放大查看图表参数对象
      showChart: {
        chartType: "",
        title: "",
        idName: "chart_vm",
        searchType: "",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
        targetCategory: [],
      },
      isShowChart: false, //放大查看图表（报表）数据
      breedTableTimer: null,
      periodName: "一造次", // 造次名称
      feedUseNum: 0, //一造次饲料使用情况总和
      resizeHandler: null,
      WarningTimer: null, //死鱼警告计时器
      feedAndDongbaoTarget: 1,
      // 日死鱼情况折线图数据对象
      SunDeadFishData: {
        ElDom: null,
        xData: [],
        yData: [],
        series: [],
        legend: [],
        //为数据准备的线条颜色
        lineColor: [
          { color: "#8631F0", lineColor: "165, 92, 255" },
          { color: "#E441BE", lineColor: "253, 128, 255" },
          { color: "#6473F5", lineColor: "165, 92, 255" },
        ],
      },
      // 饲料现存量和动保现存量数据对象
      rightCenterTwoData: {
        ElDom: null,
        xData: [],
        yData: [],
        legend: [],
      },
      // 饲料日投喂数据对象
      feedDayFeedingData: {
        ElDom: null,
        xData: [],
        yData: [],
        series: [],
        legend: [],
        //为数据准备的线条颜色
        lineColor: [
          { color: "#8631F0", lineColor: "165, 92, 255" },
          { color: "#E441BE", lineColor: "253, 128, 255" },
          { color: "#6473F5", lineColor: "165, 92, 255" },
        ],
      },
      // 动保现存量图表数据对象
      DynamicData: {
        ElDom: null,
        xData: [],
        yData: [],
        series: [],
        legend: [],
        //为数据准备的线条颜色
        lineColor: [
          { color: "#8631F0", lineColor: "165, 92, 255" },
          { color: "#E441BE", lineColor: "253, 128, 255" },
          { color: "#6473F5", lineColor: "165, 92, 255" },
        ],
      },
      // 各区域各品种死鱼情况数据对象
      DeadfishChartData: {
        ElDom: null,
        xData: [],
        yData: [],
        series: [],
        legend: [],
        warningData: [],
      },
      // 一造次各品种销售产值
      OneCakeChartData: {
        ElDom: null,
        series: [],
        other: false,
        otherData: [],
      },
      // 一造次各品种收获产量
      TwoCakeChartData: {
        ElDom: null,
        series: [],
        other: false,
        otherData: [],
      },
      // 一造次各品种收获面积
      ThreeCakeChartData: {
        ElDom: null,
        other: false,
        otherData: [],
      },
      // 一造次各品种收获塘口数data
      TangKouChartData: {
        ElDom: null,
        xData: [],
        yData: [],
        legend: [],
      },
      // 一造次各品种育苗天数与投入成本data
      dateCostChartsData: {
        ElDom: null,
        xData: [],
        option: {},
      },
      orgId: localStorage.getItem("orgId"), // 一级机构
      type: "", // 时间类型(Y: 年, M: 年月)
      year: "", // 年份(yyyy)
      month: "", // 年月(yyyy-MM)
      breedTypeClass: "fish", // 阶段类型（egg：育苗，fish：养成）
      tableOneData: [], //一造次各品种投卵情况Data
      // 一造次饲料使用情况
      tableTwoData: {
        OneTableData: [],
        TwoTableData: [],
      },
      carouselData: [],
      // 一造次销售产值data
      outputValueData: {
        saleMoney: 0, //一造次产值
        saleMoneyLast: 0, //上一造次产值
        saleMoneyPerCent: 0, //环比
      },
      // 一造次收获总产量data
      yieldData: {
        harvestYield: 0, //一造次产量
        harvestYieldLast: 0, //上一造次产量
        harvestYieldPerCent: 0, //环比
      },
      // 一造次收获总面积data
      areaData: {
        harvestArea: 0, //一造次面积
        harvestAreaLast: 0, //上一造次面积
        harvestAreaPerCent: 0, //环比
      },
      DailyFeedNum: 0, //饲料日投喂今日总量
      DailyBasisNum: 0, //动保日投用今日总量
      DeadFishNum: 0, //日死鱼情况总量
      scrollFlag: true,
      scrollFeedInterval: null,
      tableContentScrollTop: 0,
      isDown: false,
      fodderKgToJin: '公斤'   // 是否把公斤转换成斤
    };
  },
  computed: {
    feedAndMoveRouter() {
      return this.feedAndDongbaoTarget == 1 ? "day-yc-feed" : "day-yc-drug";
    },
  },
  methods: {
    // 关闭自定义formaater
    closeFormatter(option) {
      option.baseOption &&
        option.baseOption.tooltip &&
        option.baseOption.tooltip.trigger &&
        delete option.baseOption.tooltip.trigger;
      option.baseOption &&
        option.baseOption.tooltip &&
        option.baseOption.tooltip.formatter &&
        delete option.baseOption.tooltip.formatter;
      option.tooltip &&
        option.tooltip.formatter &&
        delete option.tooltip.formatter;
      option.tooltip && option.tooltip.trigger && delete option.tooltip.trigger;
    },
    // 大屏显示图表关闭事件
    isShowChartClose() {
      // 清空图表占用 防止污染接下来注册的图表
      this.showChart.chartDom && this.showChart.chartDom.dispose();
      // 默认隐藏table的Dom实例 显示图表Dom实例
      this.isShowTable = false;
      this.showChart = {
        chartType: "",
        idName: "chart_vm",
        searchType: "",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
        targetCategory: [],
      };
    },
    // 大屏显示图表点击事件
    isShowChartClick(type, showType) {
      this.isShowChart = true;
      // this.showChart.chartType = type;
      if (type === "table-one-box") {
        this.showChart.title = "各造次投苗情况列表";
        this.isShowTable = true;
      } else if (type === "tangkouCharts") {
        this.showChart.title = "各造次收获塘口数";
        this.tangkouChartsInit2(this.showChart.idName, true);
      } else if (type === "rashDateCostCharts") {
        this.showChart.title = "各造次养殖天数与投入成本";
        this.dateCostChartsInit(this.showChart.idName, true);
      } else if (type === "DailyFeedCharts") {
        this.showChart.title = "饲料日投喂";
        this.PrivateChatChartsInit(this.showChart.idName, true);
      } else if (type === "PrivateChatCharts") {
        this.showChart.title = "动保日投用";
        this.PrivateChatChartsInit2(this.showChart.idName, true);
      } else if (type === "dayDynamicProtectionCharts") {
        this.showChart.title = "日死鱼情况";
        this.SunDeadFishChartsInit(this.showChart.idName, true);
      }
    },
    /**
     * @Author: lishiqiao
     * @Date: 2022-03-17 17:22:40
     * @description: 获取图表startValue
     * @param {*} event
     * @param {*} obj
     */
    getStartValue(event) {
      let option = JSON.parse(JSON.stringify(this.dateCostChartsData.option));
      if (!option.baseOption) {
        option.animationDurationUpdate = 60;
        option.dataZoom[0].startValue = event;
      } else {
        option.baseOption.animationDurationUpdate = 60;
        option.baseOption.dataZoom[0].startValue = event;
        option.baseOption.dataZoom[1].startValue = event;
        option.baseOption.dataZoom[2].startValue = event;
      }
      this.dateCostChartsData.ElDom.setOption(option);
    },
    // 一造次各品种销售产值饼状图初始化
    outputValueChartsInit(ref) {
      let outputValueData = this.OneCakeChartData.series;
      let option = {
        left: "0",
        backgroundColor: "#1E1E2B", //背景颜色
        grid: {
          // x: 55,
          // y: 55,
        },
        color: ["#5442FF", "#F553FB", "#68DEBE", "#2BCCFA"],
        tooltip: {
          trigger: "item",
          formatter: "\n{b}\n{c}",
          position: function (point, params, dom, rect, size) {
            return [point[0] + 25, point[1] + 25];
          },
        },
        label: {
          show: true,
          formatter: "\n\n{b}\n\n{c}",
          // lineHeight:'',
          position: "outside",
          // fontSize: fontHandle(12),
        },
        labelLine: {
          lineStyle: {
            color: "#D0CCCC",
          },
          smooth: 0.2,
          length: 10,
          length2: 20,
        },
        legend: {
          top: "top",
          left: "20",
          formatter: function (name) {
            let data = outputValueData;
            let str = "";
            data.filter((item) => {
              if (name === item.name) {
                str = item.value;
              }
            });
            return "{a|" + name + ":" + str + "}";
          },
          orient: "vertical",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            // fontSize: 12, //字体大小
            color: "#D0CCCC", //字体颜色
            backgroundColor: "transparent", // 文字块背景色，一定要加上，否则对齐不会生效
            rich: {
              a: {
                width: 110,
              },
            },
          },
        },
        series: [
          {
            top: "40",
            name: "Access From",
            type: "pie",
            radius: ["10%", "65%"],
            // center: ["30%", "50%"],
            // 标示线长度控制
            itemStyle: {
              normal: {
                labelLine: {
                  length: 0, //去除多余的标示线长度
                },
              },
            },
            roseType: "area",
            data: outputValueData,
            labelLine: {
              normal: {
                minTurnAngle: 150,
                length: 5,
                length2: 10,
              },
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 10,
                },
                position: "outer",
                alignTo: "none",
              },
              emphasis: {
                show: true,
              },
            },
          },
        ],
      };
      let myChart = $echarts.init(this.$refs[ref]);
      this.OneCakeChartData.ElDom = myChart;
      myChart.setOption(option);
      myChart.on("legendselectchanged", (params) => {
        if (params.name == "其他") {
          this.OneCakeChartData.other = !this.OneCakeChartData.other;
        }
      });
      this.isDown = true;
      // myChart.resize();
    },
    // 一造次各品种收获产量饼状图初始化
    outputValueChartsInit2(ref) {
      let outputValueData = this.TwoCakeChartData.series;
      let option = {
        backgroundColor: "#1E1E2B", //背景颜色
        grid: {
          // x: 55,
          // y: 55,
          x: 10,
          y: 10,
        },
        color: ["#5442FF", "#F553FB", "#68DEBE", "#2BCCFA"],
        tooltip: {
          trigger: "item",
          formatter: "\n{b}\n{c}",
        },
        label: {
          show: true,
          formatter: "\n\n{b}\n\n{c}",
          position: "outside",
          // fontSize: fontHandle(12),
        },
        labelLine: {
          lineStyle: {
            color: "#D0CCCC",
          },
          smooth: 0.2,
          length: "1%",
          length2: "1%",
          maxSurfaceAngle: 90,
        },
        legend: {
          top: "top",
          left: "20",
          formatter: function (name) {
            let data = outputValueData;
            let str = "";
            data.filter((item) => {
              if (name === item.name) {
                str = item.value;
              }
            });
            return "{a|" + name + ":" + str + "}";
          },
          orient: "vertical",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            // fontSize: 12, //字体大小
            color: "#D0CCCC", //字体颜色
            backgroundColor: "transparent", // 文字块背景色，一定要加上，否则对齐不会生效
            rich: {
              a: {
                width: 110,
              },
            },
          },
        },
        series: [
          {
            top: "40",
            name: "Access From",
            type: "pie",
            radius: ["10%", "65%"],
            // center: ["30%", "50%"],
            // 标示线长度控制
            itemStyle: {
              normal: {
                labelLine: {
                  length: 0, //去除多余的标示线长度
                },
              },
            },
            labelLine: {
              normal: {
                minTurnAngle: 150,
                length: 5,
                length2: 10,
              },
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 10,
                },
                position: "outer",
                alignTo: "none",
              },
              emphasis: {
                show: true,
              },
            },
            roseType: "area",
            data: outputValueData,
          },
        ],
      };
      let myChart = $echarts.init(this.$refs[ref]);
      this.TwoCakeChartData.ElDom = myChart;
      myChart.setOption(option);
      myChart.on("legendselectchanged", (params) => {
        if (params.name == "其他") {
          this.TwoCakeChartData.other = !this.TwoCakeChartData.other;
        }
      });
      // myChart.resize();
    },
    // 一造次各品种收获面积饼状图初始化
    outputValueChartsInit3(ref) {
      let outputValueData = this.ThreeCakeChartData.series;
      let option = {
        backgroundColor: "#1E1E2B", //背景颜色
        grid: {
          x: 10,
          y: 10,
        },
        color: ["#5442FF", "#F553FB", "#68DEBE", "#2BCCFA"],
        tooltip: {
          trigger: "item",
          formatter: "\n{b}\n{c}",
        },
        label: {
          show: true,
          formatter: "\n\n{b}\n\n{c}",
          position: "outside",
          // fontSize: fontHandle(12),
        },
        labelLine: {
          lineStyle: {
            color: "#D0CCCC",
          },
          smooth: 0.2,
          length: 5,
          length2: 10,
        },
        legend: {
          top: "top",
          left: "20",
          formatter: function (name) {
            let data = outputValueData;
            let str = "";
            data.filter((item) => {
              if (name === item.name) {
                str = item.value;
              }
            });
            return "{a|" + name + ":" + str + "}";
          },
          orient: "vertical",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            // fontSize: 12, //字体大小
            color: "#D0CCCC", //字体颜色
            backgroundColor: "transparent", // 文字块背景色，一定要加上，否则对齐不会生效
            rich: {
              a: {
                width: 110,
              },
            },
          },
        },
        series: [
          {
            top: "40",
            name: "Access From",
            type: "pie",
            radius: ["10%", "65%"],
            // center: ["30%", "50%"],
            // 标示线长度控制
            itemStyle: {
              normal: {
                labelLine: {
                  length: 0, //去除多余的标示线长度
                },
              },
            },
            labelLine: {
              normal: {
                minTurnAngle: 150,
                length: 10,
                length2: 20,
              },
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 10,
                },
                position: "outer",
                alignTo: "none",
              },
              emphasis: {
                show: true,
              },
            },
            roseType: "area",
            data: outputValueData,
          },
        ],
      };
      let myChart = $echarts.init(this.$refs[ref]);
      this.ThreeCakeChartData.ElDom = myChart;
      myChart.setOption(option);
      myChart.on("legendselectchanged", (params) => {
        if (params.name == "其他") {
          this.ThreeCakeChartData.other = !this.ThreeCakeChartData.other;
        }
      });
      // myChart.resize();
    },
    // 私聊现存量and动保现存量接口请求函数
    ChartsCheckoutTarget(num, showBol) {
      if (num === this.feedDefaultNum) {
        if (num == 1) {
          this.showChart.title = "饲料现存量";
          setTimeout(() => {
            this.tangkouChartsInit(this.showChart.idName, true);
          });
        } else if (num == 2) {
          this.showChart.title = "动保现存量";
          setTimeout(() => {
            this.tangkouChartsInit(this.showChart.idName, true);
          });
        }
        this.isShowChartClick("stockOnHand");
        return;
      }
      this.feedDefaultNum = num;
      this.feedAndDongbaoTarget = num;
      if (!showBol) {
        this.rightCenterTwoData.ElDom &&
          this.rightCenterTwoData.ElDom.dispose();
      }
      // 切饲料现存量
      if (num == 1) {
        service
          .getMdtFodderDataGroupByChart({
            orgId: localStorage.getItem("orgId"),
            day: this.date,
          })
          .then((res) => {
            const xDataList = [];
            const yDataList = [];
            if (res.data[0]) {
              this.rightCenterTwoData.legend = [res.data[0].legendName];
              const ResArr = res.data[0].dataList;
              ResArr.map((item) => {
                xDataList.push(item.xAxisName);
                yDataList.push(item.yAxisValue);
              });
              this.rightCenterTwoData.xData = xDataList;
              this.rightCenterTwoData.yData = yDataList;
            }
            this.tangkouChartsInit("PrivateChatExistingCharts");
          });
      } else {
        // 切动保现存量
        service
          .DynamicGetChatrs({
            orgId: localStorage.getItem("orgId"),
            day: this.date,
          })
          .then((res) => {
            const xDataList = [];
            const yDataList = [];
            if (res.data[0]) {
              this.rightCenterTwoData.legend = [res.data[0].legendName];
              const ResArr = res.data[0].dataList;
              ResArr.map((item) => {
                xDataList.push(item.xAxisName);
                yDataList.push(item.yAxisValue);
              });
              this.rightCenterTwoData.xData = xDataList;
              this.rightCenterTwoData.yData = yDataList;
            }
            this.tangkouChartsInit("PrivateChatExistingCharts");
          });
      }
    },
    // 饲料现存量和动保现存量图表初始化函数
    tangkouChartsInit(ref, showBol) {
      // 柱状
      let option = {
        // backgroundColor: "#1E1E2B", //背景颜色
        tooltip: {
          trigger: "axis",
          color: "red",
          // formatter: '{b0}<br />收获塘口数: {c0}',
          formatter: (params) => {
            return `
            <div>
            <p style="margin-bottom:5px;">${params[0].axisValueLabel}</p>
            <p><span style="margin-right:5px;border-radius:2px;display:inline-block;width:8px;height:8px;background:#907BFE;"></span>库存量:${params[0].value}</p>
            </div>`;
          },
          padding: [10, 10, 10, 10], //提示内边距
        },
        grid: {
          top: showBol ? "7%" : "5%",
          left: "5%",
          right: "6%",
          bottom: "15%",
          containLabel: true,
        },
        legend: {
          data: this.rightCenterTwoData.legend,
          itemWidth: 8,
          itemHeight: 8,
          left: "10%",
          // left: "center",
          bottom: "5%",
          textStyle: {
            fontSize: showBol ? 14 : 12, //字体大小
            color: "#9BA7BF", //字体颜色
          },
        },
        xAxis: {
          type: "category",
          top: 10,
          axisTick: false, // 坐标轴小标记，默认为true
          axisLabel: {
            textStyle: {
              color: "#838DA1",
              fontSize: 12,
              fontFamily: "Microsoft YaHei",
            },
            // x轴文字倾斜
            interval: 0,
            rotate: showBol ? 0 : 60,
          },
          axisLine: {
            lineStyle: {
              color: "#46494A",
            },
          },
          data: this.rightCenterTwoData.xData,
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: [10, 10],
              color: "#46494A",
              width: 1,
            },
          },
        },
        series: [
          {
            name: this.rightCenterTwoData.legend[0],
            type: "bar",
            data: this.rightCenterTwoData.yData,
            barWidth: showBol ? "10" : "8",
            label: {
              show: showBol ? true : false,
              fontSize: 12,
              color: "#ffffff",
              position: "top",
              formatter: (params) => {
                if (params.value == 0) {
                  return ``;
                }
                return params.value; //随便写的值
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#907BFE" },
                { offset: 1, color: "#5442FF" },
              ]),
              barBorderRadius: [30, 30, 30, 30], //圆角大小
            },
          },
        ],
      };
      let myChart = $echarts.init(this.$refs[ref]);
      if (showBol) {
        this.showChart.chartDom = myChart;
        this.closeFormatter(option);
      }
      this.rightCenterTwoData.ElDom = myChart;
      myChart.setOption(option);
    },
    // 一造次各品种收获塘口数柱状图初始化
    tangkouChartsInit2(ref, showBol) {
      if (!showBol) {
        this.TangKouChartData.ElDom && this.TangKouChartData.ElDom.dispose();
      }
      service
        .getBreedNameChartForHarvestBoxNum({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "fish",
        })
        .then((res) => {
          let xDataList = [];
          let yDataList = [];
          let legend = [];
          if (res.data[0]) {
            res.data[0].dataList.forEach((item) => {
              xDataList.push(item.xAxisName);
              yDataList.push(item.yAxisValue);
            });
            legend = [res.data[0].legendName];
            this.TangKouChartData.xData = xDataList;
            this.TangKouChartData.yData = yDataList;
            this.TangKouChartData.legend = legend;
          }
          // 柱状
          let option = {
            // backgroundColor: "#1E1E2B", //背景颜色
            tooltip: {
              trigger: "axis",
              color: "red",
              formatter: (params) => {
                return `
            <div>
            <p style="margin-bottom:5px;">${params[0].axisValueLabel}</p>
            <p><span style="margin-right:5px;border-radius:2px;display:inline-block;width:8px;height:8px;background:#907BFE;"></span>收获塘口数:${params[0].value}</p>
            </div>`;
              },
              padding: [10, 10, 10, 10], //提示内边距
            },
            grid: {
              top: showBol ? "7%" : "5%",
              left: "5%",
              right: "6%",
              bottom: "15%",
              containLabel: true,
            },
            legend: {
              data: this.TangKouChartData.legend,
              itemWidth: 8,
              itemHeight: 8,
              left: "10%",
              // left: "center",
              bottom: "5%",
              textStyle: {
                fontSize: 12, //字体大小
                color: "#9BA7BF", //字体颜色
              },
            },
            xAxis: {
              type: "category",
              top: 10,
              axisTick: false, // 坐标轴小标记，默认为true
              axisLabel: {
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                },
                // x轴文字倾斜
                interval: 0,
                rotate: 70,
              },
              axisLine: {
                lineStyle: {
                  color: "#46494A",
                },
              },
              data: this.TangKouChartData.xData,
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  type: [10, 10],
                  color: "#46494A",
                  width: 1,
                },
              },
            },
            series: [
              {
                name: this.TangKouChartData.legend[0],
                type: "bar",
                data: this.TangKouChartData.yData,
                barWidth: showBol ? "10" : "8",
                label: {
                  normal: {
                    show: showBol ? true : false,
                    position: "center",
                    textStyle: {
                      color: "white",
                      fontStyle: "normal",
                      fontFamily: "微软雅黑",
                      fontSize: 12,
                    },
                    // offset: [0, 0],
                    distance: "10",
                    rotate: "90",
                    formatter: (param) => {
                      if (param.value == 0) {
                        return ``;
                      }
                      return param.value;
                    },
                  },
                },
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#907BFE" },
                    { offset: 1, color: "#5442FF" },
                  ]),
                  barBorderRadius: [30, 30, 30, 30], //圆角大小
                },
              },
            ],
          };
          let myChart = $echarts.init(this.$refs[ref]);
          if (showBol) {
            this.showChart.chartDom = myChart;
            this.closeFormatter(option);
          }
          this.TangKouChartData.ElDom = myChart;
          myChart.setOption(option);
        })
        .catch((err) => console.log(err));
    },
    // 一造次各品种育苗天数与投入成本双X轴柱状图初始化
    dateCostChartsInit(ref, showBol) {
      if (!showBol) {
        this.dateCostChartsData.ElDom &&
          this.dateCostChartsData.ElDom.dispose();
      }
      service
        .getMdtHarvestAnalysisOrgByChart({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "fish",
        })
        .then((res) => {
          const data = res.data;
          let legendName =
            data.map((re) => {
              return re.legendName;
            }) || [];
          let xData = [];
          let leftData = []; //育苗天数data
          let rightData = []; //累计投入成本data
          if (data[0]) {
            xData = res.data[0].dataList.map((item) => {
              return item.xAxisName;
            });
            this.dateCostChartsData.xData = xData;
            data.forEach((item) => {
              if (item.legendName === "养殖天数") {
                leftData = item.dataList.map((item) => {
                  return item.yAxisValue;
                });
              }
              if (item.legendName === "累计成本投入") {
                rightData = item.dataList.map((item) => {
                  return item.yAxisValue;
                });
              }
            });
          }
          var background = "#1E1E2B"; //背景
          let textColor = "#838DA1"; //文字颜色
          let lineColor = "#46494A";
          let colors = [
            {
              borderColor: "rgba(227,161,96,1)",
              start: "rgba(241, 97, 246, 1)",
              end: "rgba(178, 31, 183, 1)",
            },
            {
              borderColor: "rgba(0,222,255,1)",
              start: "rgba(84, 66, 255, 1)",
              end: "rgba(144, 123, 254, 1)",
            },
          ];
          var option = {
            baseOption: {
              backgroundColor: background,
              timeline: {
                show: false,
                top: 0,
                data: [],
              },
              grid: [
                {
                  show: false,
                  left: "7%",
                  top: "7%",
                  bottom: "7%",
                  containLabel: true,
                  width: "37%",
                },
                {
                  show: false,
                  left: "52.5%",
                  top: "7%",
                  bottom: "13%",
                  width: "0%",
                },
                {
                  show: false,
                  right: "7%",
                  top: "7%",
                  bottom: "7%",
                  containLabel: true,
                  width: "37.6%",
                },
              ],
              tooltip: {
                trigger: "item",
                formatter: (params) => {
                  return `
            <div>
            <p style="text-align:center;margin-bottom:5px;">${params.name}(${
                    params.seriesName
                  })</p>
            <p><span style="margin-right:5px;border-radius:2px;display:inline-block;width:8px;height:8px;background:${
              params.seriesName === "养殖天数" ? "#F161F6" : "#5442FF"
            };"></span>数值:${params.value}</p>
            </div>`;
                },
              },
              xAxis: [
                {
                  type: "value",
                  inverse: true,
                  position: "bottom",
                  axisLabel: {
                    show: true,
                    color: textColor,
                  },
                  splitNumber: 2,
                  axisTick: {
                    show: false,
                    interval: 6,
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: lineColor,
                    },
                  },
                },
                {
                  gridIndex: 1,
                  show: false,
                },
                {
                  gridIndex: 2,
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                  position: "bottom",
                  splitNumber: 2,
                  axisLabel: {
                    show: true,
                    color: textColor,
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: lineColor,
                    },
                  },
                },
              ],
              yAxis: [
                {
                  type: "category",
                  inverse: true,
                  position: "right",
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: lineColor,
                    },
                  },

                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    show: false,
                  },
                  data: xData,
                },
                {
                  gridIndex: 1,
                  type: "category",
                  inverse: true,
                  position: "left",
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    show: true,
                    padding: [30, 30, 30, 30],
                    textStyle: {
                      color: "#838DA1",
                      fontSize: 8,
                    },
                    align: "center",
                  },
                  data: xData.map(function (value) {
                    return {
                      value: value,
                      textStyle: {
                        align: "center",
                      },
                    };
                  }),
                },
                {
                  gridIndex: 2,
                  type: "category",
                  inverse: true,
                  position: "left",
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: lineColor,
                    },
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    show: false,
                  },
                  data: xData,
                },
              ],
              series: [],
            },
            options: [],
          };
          option.options.push({
            series: [
              {
                name: "养殖天数",
                type: "bar",
                barWidth: 8,
                stack: "1",
                itemStyle: {
                  normal: {
                    barBorderRadius: 10,
                    color: new $echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: colors[0].start,
                      },
                      {
                        offset: 1,
                        color: colors[0].end,
                      },
                    ]),
                  },
                },
                label: {
                  normal: {
                    show: true,
                    fontSize: 8,
                    position: "left",
                    textStyle: { color: "white" },
                  },
                },
                data: leftData,
                animationEasing: "elasticOut",
              },
              {
                name: "累计投入成本",
                type: "bar",
                stack: "2",
                barWidth: 8,
                xAxisIndex: 2,
                yAxisIndex: 2,
                itemStyle: {
                  normal: {
                    barBorderRadius: 10,
                    color: new $echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: colors[1].start,
                      },
                      {
                        offset: 1,
                        color: colors[1].end,
                      },
                    ]),
                  },
                },
                label: {
                  normal: {
                    show: true,
                    fontSize: 8,
                    position: "right",
                    textStyle: { color: "white" },
                  },
                },
                data: rightData,
                animationEasing: "elasticOut",
              },
            ],
          });

          let option3 = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
              textStyle: {
                color: "#111E39",
                fontSize: 12,
                fontFamily: "Microsoft YaHei",
                fontWeight: 400,
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  if (item.seriesName.includes("累计成本投入")) {
                    dataStr += `<div style=${
                      !item.data ? "display:none;" : "display:block"
                    }>
                 <div style="margin: 0 8px;">
                   <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
                     typeof item.color == "object"
                       ? item.color.colorStops[0].color
                       : ""
                   } 0%, ${
                      typeof item.color == "object"
                        ? item.color.colorStops[1].color
                        : ""
                    } 100%);"></span>
                   <span>${item.seriesName}</span>
                   <span style="float:right;color:#000000;margin-left:20px;">${
                     item.data
                   }</span>
                 </div>
               </div>`;
                  } else {
                    dataStr += `<div style=${
                      !item.data ? "display:none;" : "display:block"
                    }>
                 <div style="margin: 0 6px;">
                   <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
                   ">
                  <svg class="icon" style="position:absolute;top:-9px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path d="M682.667 307.2c17.066 0 34.133 17.067 34.133 34.133v341.334c0 17.066-17.067 34.133-34.133 34.133H341.333c-17.066 0-34.133-17.067-34.133-34.133V341.333c0-17.066 17.067-34.133 34.133-34.133h341.334m0-136.533H341.333c-93.866 0-170.666 76.8-170.666 170.666v341.334c0 93.866 76.8 170.666 170.666 170.666h341.334c93.866 0 170.666-76.8 170.666-170.666V341.333c0-93.866-76.8-170.666-170.666-170.666z" fill="${
                    item.color
                  }"/></svg>
                   </span>
                   <span>${item.seriesName}</span>
                   <span style="float:right;color:#000000;margin-left:20px;">${
                     item.data
                   } </span>
                 </div>
               </div>`;
                  }
                });
                return dataStr;
              },
            },
            legend: {
              type: "scroll",
              bottom: 20,
              left: 30,
              itemHeight: 8,
              itemGap: 40,
              itemWidth: 8,
              textStyle: {
                //图例文字的样式
                fontSize: "12px",
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#9BA7BF",
              },
              pageTextStyle: {
                color: "#9BA7BF",
                fontSize: 12,
                fontFamily: "SimSun",
              },
              pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
              pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
              pageIconSize: 11, //翻页按钮大小
              data: legendName.map((item) => {
                if (item.includes("累计成本投入")) {
                  return {
                    name: item,
                    icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                  };
                } else {
                  return {
                    name: "养殖天数",
                    icon: "path://M682.666667 588.8c17.066667 0 34.133333-17.066667 34.133333-34.133333v-341.333334c0-17.066667-17.066667-34.133333-34.133333-34.133333H341.333333c-17.066667 0-34.133333 17.066667-34.133333 34.133333V554.666667c0 17.066667 17.066667 34.133333 34.133333 34.133333h341.333334M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                  };
                }
              }),
            },
            grid: {
              right: 30,
              top: showBol ? 50 : 20,
              bottom: showBol ? 80 : 55,
              left: 30,
              width: "auto",
              containLabel: true,
            },
            dataZoom: [
              {
                dataBackground: {
                  //未选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                selectedDataBackground: {
                  //选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                type: "slider",
                show: showBol ? true : false,
                right: 33,
                bottom: 60,
                height: 6,
                borderColor: "#383848", //缩放条边框颜色
                fillerColor: "#383848", //选中的阴影填充背景颜色
                backgroundColor: "rgb(30,30,43)", // 背景颜色
                maxValueSpan: 6,
                handleSize: 0,
                brushSelect: false,
                showDetail: false,
                moveHandleStyle: {},
              },
            ],
            xAxis: {
              type: "category",
              axisPointer: {
                type: "shadow",
              },
              axisTick: {
                show: false,
              },
              // axisLabel: {
              //   interval: 0,
              //   margin: 10,
              //   textStyle: {
              //     fontSize: 12,
              //     fontFamily: "SimSun",
              //     fontWeight: 400,
              //     color: "#838DA1",
              //   },
              //   // x轴文字倾斜
              //   rotate: 70,
              // },
              axisLabel: {
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                },
                // x轴文字倾斜
                interval: 0,
                rotate: showBol ? 60 : 70,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
              data: xData,
            },
            yAxis: [
              {
                type: "value",
                min: 0,
                // axisLabel: {
                // margin: 15,
                // textStyle: {
                // fontSize: 12,
                // fontFamily: "SimSun",
                // fontWeight: 400,
                // color: "#838DA1",
                // },
                // formatter: "{value}",
                // },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                    type: [10, 10],
                    dashOffset: 5,
                  },
                },
              },
              {
                type: "value",
                interval: 10,
                axisLabel: {
                  margin: 10,
                  textStyle: {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#838DA1",
                  },
                  formatter: "",
                },
                splitLine: {
                  show: false,
                },
              },
            ],
            series: legendName.map((item, idx) => {
              if (item.includes("累计成本投入")) {
                return {
                  name: "累计成本投入",
                  type: "bar",
                  tooltip: {
                    valueFormatter: function (value) {
                      return value;
                    },
                  },
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[1].start },
                      { offset: 0, color: colors[1].end },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[1].start },
                        { offset: 0, color: colors[1].end },
                      ]),
                    },
                  },
                  barMaxWidth: showBol ? "10" : "4",
                  barGap: showBol ? 1 : 3,
                  label: {
                    show: showBol ? true : false,
                    position: showBol ? "top" : "center",
                    textStyle: {
                      color: "white",
                      fontStyle: "normal",
                      fontFamily: "微软雅黑",
                      fontSize: 12,
                    },
                    // offset: [0, 0],
                    distance: "10",
                    rotate: showBol ? "0" : "90",
                    formatter: (param) => {
                      if (param.value == 0) {
                        return ``;
                      }
                      return param.value;
                    },
                  },
                  data: rightData,
                };
              } else {
                return {
                  name: "养殖天数",
                  type: "line",
                  yAxisIndex: 1,
                  lineStyle: {
                    color: colors[0].start,
                    width: 2,
                  },
                  // emphasis: {
                  //   focus: "series",
                  // },
                  label: {
                    show: showBol ? true : false,
                    fontSize: 12,
                    // textStyle:{
                    //   color:"red",
                    //   fontSize:16
                    // },
                    color: colors[0].start,
                    position: "top",
                    distance: "10",
                    formatter: (params) => {
                      return params.value + "天"; //随便写的值
                    },
                  },
                  color: colors[0].start,
                  symbol: showBol ? "" : "none", //去掉折线图中的节点
                  smooth: true, //true 为平滑曲线，false为直线
                  connectNulls: true,
                  // showSymbol: leftData.length == 1 ? true : false,
                  data: leftData,
                };
              }
            }),
          };
          let myChart = $echarts.init(this.$refs[ref]);
          if (showBol) {
            this.showChart.chartDom = myChart;
            this.closeFormatter(option3);
          }
          this.dateCostChartsData.ElDom = myChart;
          myChart.setOption(option3);
          this.dateCostChartsData.option = option3;
        })
        .catch((err) => console.log(err));
    },
    // 饲料日投喂折线图初始化函数
    PrivateChatChartsInit(ref, showBol) {
      if (!showBol) {
        this.feedDayFeedingData.ElDom &&
          this.feedDayFeedingData.ElDom.dispose();
      }
      service
        .getPrivateChatCharts({
          orgId: localStorage.getItem("orgId"),
          breedTypeClass: "fish",
          day: this.date,
        })
        .then((r) => {
          let num = 0;
          const res = r.data;
          const xDataList = [];
          const legendList = [];
          const dataSeries = [];
          if (res[0]) {
            // 根据数据动态生成series数量
            res[0].dataList.forEach((item, index) => {
              xDataList.push(item.xAxisName);
            });
            res.forEach((item, index) => {
              item.dataList.forEach((item) => {
                if (item.xAxisName === this.date) {
                  num = Page.numAdd(num, item.yAxisValue);
                }
              });
              dataSeries.push({
                name: item.legendName,
                data: [],
              });
            });
            this.DailyFeedNum = num;
            // 推入legend 计算每行数据
            for (let i = 0; i < res.length; i++) {
              legendList.push(res[i].legendName);
              if (res[i].legendName === dataSeries[i].name) {
                res[i].dataList.forEach((item) => {
                  dataSeries[i].data.push(item.yAxisValue);
                });
              }
            }
            dataSeries.forEach((item, index) => {
              if (index > 2) {
                this.feedDayFeedingData.lineColor.push({
                  color: this.$color.randex(),
                  lineColor: this.$color.handleColorsTwo(),
                });
              }
              (item.name = item.name),
                (item.data = item.data),
                (item.symbolSize = 0), //折线点的大小
                (item.itemStyle = {
                  normal: {
                    color: this.feedDayFeedingData.lineColor[index].color,
                    lineStyle: {
                      width: 2, //设置线条粗细
                    },
                  },
                }),
                (item.areaStyle = {
                  //区域填充样式
                  normal: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: `rgba(${this.feedDayFeedingData.lineColor[index].lineColor}, 0.1)`,
                      },
                      {
                        offset: 0.1,
                        color: `rgba(${this.feedDayFeedingData.lineColor[index].lineColor}, 0.3)`,
                      },
                      {
                        offset: 0.7,
                        color: `rgba(${this.feedDayFeedingData.lineColor[index].lineColor}, 0)`,
                      },
                    ]),
                  },
                }),
                (item.type = showBol ? "bar" : "line"),
                (item.smooth = true);
              item.label = {
                show: showBol ? true : false,
                fontSize: 12,
                // textStyle:{
                //   color:"red",
                //   fontSize:16
                // },
                color: "white",
                position: "top",
                distance: "10",
                formatter: (params) => {
                  return params.value; //随便写的值
                },
              };
            });
            this.feedDayFeedingData.series = dataSeries;
            this.feedDayFeedingData.xData = xDataList;
            this.feedDayFeedingData.legend = legendList;
          }
          let option = {
            grid: {
              top: "20%",
              left: "12%",
              right: "5%",
            },
            // backgroundColor: "#1E1E2B", //背景颜色
            legend: {
              icon: "roundRect",
              textStyle: {
                fontSize: 12, //字体大小
                color: "#9BA7BF", //字体颜色
              },
              left: "10%",
              itemWidth: 8,
              itemHeight: 8,
              // 自定义icon
              // icon: "path://M78.625,93.094L66.494,72.081l12.132-21.013h24.264l12.132,21.013l-12.132,21.013H78.625z M95.547,80.377l4.79-8.296  l-4.79-8.296h-9.579l-4.79,8.296l4.79,8.296H95.547z",
              data: this.feedDayFeedingData.legend,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                lineStyle: {
                  type: "line",
                  width: "1",
                  color: "#46494A",
                },
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  dataStr += `<div>
            <div style="margin: 0 6px;">
              <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
              ">
              <svg class="icon"  style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:${item.color};"/></svg>
              </span>
              <span>${item.seriesName}</span>
              <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
            </div>
          </div>`;
                });
                return dataStr;
              },
            },
            dataZoom: [
              {
                bottom: "20",
                right: "35",
                left: "60",
                height: "6",
                type: "slider", //图表下方的伸缩条
                show: true, //是否显示
                start: 0, //伸缩条开始位置（1-100），可以随时更改
                end: 100, //伸缩条结束位置（1-100），可以随时更改
                dataBackground: {
                  //未选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                selectedDataBackground: {
                  //选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                // textStyle:false,
                showDetail: false,
                height: "6",
                borderColor: "#383848", //缩放条边框颜色
                fillerColor: "#383848", //选中的阴影填充背景颜色
                handleSize: "14",
                handleStyle: {
                  color: "#48485A",
                  borderWidth: "0", //去除缩放手柄描边
                },
                // 自定义缩放手柄图标
                handleIcon:
                  "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z",
                moveHandleSize: "0", //拖拽手柄尺寸大小
                moveHandleStyle: {
                  borderMiterLimit: 10,
                },
              },
            ],
            xAxis: {
              type: "category",
              data: this.feedDayFeedingData.xData,
              axisTick: {
                show: false,
              },
              axisLabel: {
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  type: [10, 10],
                  color: "#46494A",
                  width: 1,
                },
              },
            },
            series: this.feedDayFeedingData.series,
          };
          if (showBol) {
            option.dataZoom[0].maxValueSpan = 10; //区域内最多片段数据显示量
            option.dataZoom[0].zoomLock = true; //固定只能拖动不能缩放
            option.dataZoom[0].brushSelect = false; //禁用十字拖拽
          }
          let myChart = $echarts.init(this.$refs[ref]);
          if (showBol) {
            this.showChart.chartDom = myChart;
            this.closeFormatter(option);
          }
          this.feedDayFeedingData.ElDom = myChart;
          myChart.setOption(option);
        });
    },
    // 日死鱼情况折线图初始化函数
    SunDeadFishChartsInit(ref, showBol) {
      if (!showBol) {
        this.SunDeadFishData.ElDom && this.SunDeadFishData.ElDom.dispose();
      }
      service
        .getSundeadfishCharts({
          orgId: localStorage.getItem("orgId"),
          breedTypeClass: "fish",
          day: this.date,
        })
        .then((r) => {
          let num = 0;
          const res = r.data;
          const xDataList = [];
          const legendList = [];
          const dataSeries = [];
          this.SunDeadFishData.series = dataSeries;
          this.SunDeadFishData.xData = xDataList;
          this.SunDeadFishData.legend = legendList;
          if (res[0]) {
            // 根据数据动态生成series数量
            res[0].dataList.forEach((item, index) => {
              xDataList.push(item.xAxisName);
            });
            res.forEach((item, index) => {
              item.dataList.forEach((item) => {
                if (item.xAxisName === this.date) {
                  num = Page.numAdd(num, item.yAxisValue);
                }
              });
              dataSeries.push({
                name: item.legendName,
                data: [],
              });
            });
            this.DeadFishNum = num;
            // 推入legend 计算每行数据
            for (let i = 0; i < res.length; i++) {
              legendList.push(res[i].legendName);
              if (res[i].legendName === dataSeries[i].name) {
                res[i].dataList.forEach((item) => {
                  dataSeries[i].data.push(item.yAxisValue);
                });
              }
            }
            dataSeries.forEach((item, index) => {
              if (index > 2) {
                this.SunDeadFishData.lineColor.push({
                  color: this.$color.randex(),
                  lineColor: this.$color.handleColorsTwo(),
                });
              }
              (item.name = item.name),
                (item.data = item.data),
                (item.symbolSize = 0), //折线点的大小
                (item.itemStyle = {
                  normal: {
                    color: this.SunDeadFishData.lineColor[index].color,
                    lineStyle: {
                      width: 2, //设置线条粗细
                    },
                  },
                }),
                (item.areaStyle = {
                  //区域填充样式
                  normal: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: `rgba(${this.SunDeadFishData.lineColor[index].lineColor}, 0.1)`,
                      },
                      {
                        offset: 0.1,
                        color: `rgba(${this.SunDeadFishData.lineColor[index].lineColor}, 0.3)`,
                      },
                      {
                        offset: 0.7,
                        color: `rgba(${this.SunDeadFishData.lineColor[index].lineColor}, 0)`,
                      },
                    ]),
                  },
                }),
                (item.type = showBol ? "bar" : "line"),
                (item.smooth = true);
              item.label = {
                show: showBol ? true : false,
                fontSize: 12,
                // textStyle:{
                //   color:"red",
                //   fontSize:16
                // },
                color: "white",
                position: "top",
                distance: "10",
                formatter: (params) => {
                  return params.value; //随便写的值
                },
              };
            });
            this.SunDeadFishData.series = dataSeries;
            this.SunDeadFishData.xData = xDataList;
            this.SunDeadFishData.legend = legendList;
          }
          let option = {
            grid: {
              top: "20%",
              left: "12%",
              right: "5%",
            },
            // backgroundColor: "#1E1E2B", //背景颜色
            legend: {
              icon: "roundRect",
              textStyle: {
                fontSize: 12, //字体大小
                color: "#9BA7BF", //字体颜色
              },
              left: "10%",
              itemWidth: 8,
              itemHeight: 8,
              // 自定义icon
              // icon: "path://M78.625,93.094L66.494,72.081l12.132-21.013h24.264l12.132,21.013l-12.132,21.013H78.625z M95.547,80.377l4.79-8.296  l-4.79-8.296h-9.579l-4.79,8.296l4.79,8.296H95.547z",
              data: this.SunDeadFishData.legend,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                lineStyle: {
                  type: "line",
                  width: "1",
                  color: "#46494A",
                },
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  dataStr += `<div>
            <div style="margin: 0 6px;">
              <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
              ">
              <svg class="icon"  style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:${item.color};"/></svg>
              </span>
              <span>${item.seriesName}</span>
              <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
            </div>
          </div>`;
                });
                return dataStr;
              },
            },
            dataZoom: [
              {
                bottom: "20",
                right: "35",
                left: "60",
                height: "6",
                type: "slider", //图表下方的伸缩条
                show: true, //是否显示
                start: 0, //伸缩条开始位置（1-100），可以随时更改
                end: 100, //伸缩条结束位置（1-100），可以随时更改
                dataBackground: {
                  //未选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                selectedDataBackground: {
                  //选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                // textStyle:false,
                showDetail: false,
                borderColor: "#383848", //缩放条边框颜色
                fillerColor: "#383848", //选中的阴影填充背景颜色
                handleSize: "14",
                handleStyle: {
                  color: "#48485A",
                  borderWidth: "0", //去除缩放手柄描边
                },
                // 自定义缩放手柄图标
                handleIcon:
                  "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z",
                moveHandleSize: "0", //拖拽手柄尺寸大小
                moveHandleStyle: {
                  borderMiterLimit: 10,
                },
              },
            ],
            xAxis: {
              type: "category",
              data: this.SunDeadFishData.xData,
              axisTick: {
                show: false,
              },
              axisLabel: {
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  type: [10, 10],
                  color: "#46494A",
                  width: 1,
                },
              },
            },
            series: this.SunDeadFishData.series,
          };
          if (showBol) {
            option.dataZoom[0].maxValueSpan = 10; //区域内最多片段数据显示量
            option.dataZoom[0].zoomLock = true; //固定只能拖动不能缩放
            option.dataZoom[0].brushSelect = false; //禁用十字拖拽
          }
          let myChart = $echarts.init(this.$refs[ref]);
          if (showBol) {
            this.showChart.chartDom = myChart;
            this.closeFormatter(option);
          }
          this.SunDeadFishData.ElDom = myChart;
          myChart.setOption(option);
        });
    },
    // 各区域各品种死鱼情况堆叠柱状图
    SaveDynamicProtectionChartsInit(ref) {
      service
        .ycChaartGetPeriodld({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "fish",
        })
        .then((res) => {
          this.DeadfishChartData.ElDom &&
            this.DeadfishChartData.ElDom.dispose();
          service
            .regionDeadFishCharts({
              orgId: localStorage.getItem("orgId"),
              day: this.date,
              firstDay: localStorage.getItem("m-startDate") ? localStorage.getItem("m-startDate") : this.$moment(new Date()).format("YYYY-MM-DD"),
              // periodId: res.data.periodId,
            })
            .then((r) => {
              const option4Data = [];
              const dataSeries = [];
              const yDataList = [];
              const legendList = [];
              let warningNews = r.data.warningList;
              const res = r.data.dailyDeadList;
              if (res[0]) {
                res[0].dataList.forEach((item) => {
                  yDataList.push(item.xAxisName);
                });
                res.forEach((item, index) => {
                  legendList.push(item.legendName);
                  const seriesData = {
                    name: item.legendName,
                    data: [],
                  };
                  item.dataList.forEach((item2) => {
                    seriesData.data.push(item2.yAxisValue);
                  });
                  dataSeries.push(seriesData);
                });
                dataSeries.forEach((item, index) => {
                  option4Data.push(item.data);
                  Object.assign(item, {
                    type: "bar",
                    stack: "total",
                    barWidth: "8",
                    itemStyle: {
                      normal: {
                        barBorderRadius: [0, 0, 0, 0],
                      },
                    },
                    index: index,
                  });
                });
                dataSeries.push({
                  name: "合计",
                  type: "bar",
                  stack: "total",
                  label: {
                    normal: {
                      show: true,
                      position: "right",
                      textStyle: {
                        color: "white",
                      },
                      formatter: (params) => {
                        let index = params.dataIndex;
                        let arr = option4Data;
                        let totalNum = 0;
                        for (let i = 0; i < arr.length; i++) {
                          let num = arr[i][index];
                          if (num) {
                            totalNum += num;
                          }
                        }
                        if (totalNum === 0 || NaN) {
                          return "";
                        }
                        return totalNum;
                      },
                    },
                  },
                  //思路一：给series集合末尾多加一栏用于展示合计但是值都是0；
                  //缺点：必须根据xAxis的data生成一组为空的数据，且tooltip不能加trigger: 'axis',这个条件，不然会展示合计：0
                  data: [0, 0, 0, 0, 0, 0, 0],
                });
              }
              this.DeadfishChartData.yData = yDataList;
              this.DeadfishChartData.legend = legendList;
              if (warningNews.length) {
                this.DeadfishChartData.warningData = warningNews;
              } else {
                this.DeadfishChartData.warningData = ["暂无预警数据"];
              }
              clearInterval(this.WarningTimer);
              setTimeout(() => {
                let warningUlbox = this.$refs.warningbox;
                let maxScrollTop = warningUlbox.scrollHeight - 40;
                this.WarningTimer = setInterval(() => {
                  if (warningUlbox.scrollTop >= maxScrollTop) {
                    warningUlbox.scrollTop = 0;
                  }
                  warningUlbox.scrollTop += 1;
                }, 100);
              });
              // Y轴堆叠伸柱状图
              let option4 = {
                color: ["#68DEBE", "#F553FB", "#2BCCFA", "#5442FF", "#7668FF"],
                backgroundColor: "#1E1E2B", //背景颜色
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    // Use axis to trigger tooltip
                    type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
                  },
                  formatter: (params) => {
                    let html = "";
                    params.forEach((item) => {
                      if (item.seriesName === "合计") {
                        return;
                      } else {
                        html += `<span style="margin-right:5px;border-radius:2px;display:inline-block;width:8px;height:8px; background:${item.color};"></span>${item.seriesName}:${item.value} </br>`;
                      }
                    });
                    return html;
                  },
                },
                legend: {
                  left: "10%",
                  top: "-1%",
                  textStyle: {
                    fontSize: 12, //字体大小
                    color: "#9BA7BF", //字体颜色
                    rich: {
                      a: {
                        width: 90,
                      },
                    },
                  },
                  data: this.DeadfishChartData.legend,
                  itemWidth: 8,
                  itemHeight: 8,
                },
                grid: {
                  top: "15%",
                  left: "3%",
                  right: "15%",
                  bottom: "5%",
                  containLabel: true,
                },
                xAxis: {
                  type: "value",
                  splitLine: {
                    lineStyle: {
                      color: "#46494A",
                      width: 1,
                    },
                  },
                  splitNumber: 3,
                },
                yAxis: {
                  type: "category",
                  axisTick: false, // 坐标轴小标记，默认为true
                  data: this.DeadfishChartData.yData,
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#46494A",
                    },
                  },
                },
                series: dataSeries,
              };
              let fun1 = (params) => {
                let index = params.dataIndex;
                let arr = option4Data;
                if (!falseArr.length) {
                  let totalNum = 0;
                  for (let i = 0; i < arr.length; i++) {
                    let num = arr[i][index];
                    totalNum += num;
                  }
                  if (String(totalNum) == "NaN" || String(totalNum) == "0") {
                    return "";
                  }
                  return totalNum;
                }
                let totalNum = 0;
                for (let i = 0; i < arr.length; i++) {
                  let num = arr[i][index];
                  if (falseArr.includes(i)) {
                    num = 0;
                  }
                  totalNum += num;
                }
                if (String(totalNum) == "NaN" || String(totalNum) == "0") {
                  return "";
                }
                return totalNum;
              };
              let myChart = $echarts.init(this.$refs[ref]);
              this.DeadfishChartData.ElDom = myChart;
              myChart.setOption(option4);
              let falseArr = [];
              myChart.on("legendselectchanged", function (params) {
                // 里面会有默认形参
                let selected = params.selected;
                for (let key in selected) {
                  if (!selected[key]) {
                    for (let i = 0; i <= option4.series.length; i++) {
                      try {
                        var changename = option4.series[i]["name"];
                        if (changename == key) {
                          //得到状态是true的legend对应的series的下标
                          falseArr.push(i);
                        }
                      } catch (err) {
                        break;
                      }
                    }
                  }
                }
                option4.series[option4.series.length - 1]["label"]["normal"][
                  "formatter"
                ] = fun1;
                myChart.setOption(option4);
                falseArr = [];
              });
            });
        });
    },
    // 动保日投用初始化函数
    PrivateChatChartsInit2(ref, showBol) {
      if (!showBol) {
        this.DynamicData.ElDom && this.DynamicData.ElDom.dispose();
      }
      service
        .getDynamicCharts({
          orgId: localStorage.getItem("orgId"),
          breedTypeClass: "fish",
          day: this.date,
        })
        .then((r) => {
          let num = 0;
          const res = r.data;
          // res[0].dataList[1].yAxisValue=1000
          const dataSeries = [];
          const xDataList = [];
          const legendList = [];
          if (res[0]) {
            // 根据数据动态生成series数量
            res[0].dataList.forEach((item, index) => {
              xDataList.push(item.xAxisName);
            });
            res.forEach((item, index) => {
              item.dataList.forEach((item) => {
                if (item.xAxisName === this.date) {
                  num = Page.numAdd(num, item.yAxisValue);
                }
              });
              dataSeries.push({
                name: item.legendName,
                data: [],
              });
            });
            // 这里进行单位除10000的处理
            this.DailyBasisNum = Page.numDiv(num, 10000).toFixed(4);
            // 推入legend 计算每行数据
            for (let i = 0; i < res.length; i++) {
              legendList.push(res[i].legendName);
              if (res[i].legendName === dataSeries[i].name) {
                res[i].dataList.forEach((item) => {
                  dataSeries[i].data.push(item.yAxisValue);
                });
              }
            }
            dataSeries.forEach((item, index) => {
              if (index > 2) {
                this.DynamicData.lineColor.push({
                  color: this.$color.randex(),
                  lineColor: this.$color.handleColorsTwo(),
                });
              }
              (item.name = item.name),
                (item.data = item.data),
                (item.symbolSize = 0), //折线点的大小
                (item.itemStyle = {
                  normal: {
                    color: this.DynamicData.lineColor[index].color,
                    lineStyle: {
                      width: 2, //设置线条粗细
                    },
                  },
                }),
                (item.areaStyle = {
                  //区域填充样式
                  normal: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: `rgba(${this.DynamicData.lineColor[index].lineColor}, 0.1)`,
                      },
                      {
                        offset: 0.1,
                        color: `rgba(${this.DynamicData.lineColor[index].lineColor}, 0.3)`,
                      },
                      {
                        offset: 0.7,
                        color: `rgba(${this.DynamicData.lineColor[index].lineColor}, 0)`,
                      },
                    ]),
                  },
                }),
                (item.type = showBol ? "bar" : "line"),
                (item.smooth = true);
              item.label = {
                show: showBol ? true : false,
                fontSize: 12,
                // textStyle:{
                //   color:"red",
                //   fontSize:16
                // },
                color: "white",
                position: "top",
                distance: "10",
                formatter: (params) => {
                  return params.value; //随便写的值
                },
              };
            });
            this.DynamicData.series = dataSeries;
            this.DynamicData.xData = xDataList;
            this.DynamicData.legend = legendList;
          }
          let option = {
            grid: {
              top: "20%",
              left: "12%",
              right: "5%",
            },
            // backgroundColor: "#1E1E2B", //背景颜色
            legend: {
              icon: "roundRect",
              textStyle: {
                fontSize: 12, //字体大小
                color: "#9BA7BF", //字体颜色
              },
              left: "10%",
              itemWidth: 8,
              itemHeight: 8,
              // 自定义icon
              // icon: "path://M78.625,93.094L66.494,72.081l12.132-21.013h24.264l12.132,21.013l-12.132,21.013H78.625z M95.547,80.377l4.79-8.296  l-4.79-8.296h-9.579l-4.79,8.296l4.79,8.296H95.547z",
              data: this.DynamicData.legend,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                lineStyle: {
                  type: "line",
                  width: "1",
                  color: "#46494A",
                },
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  dataStr += `<div>
            <div style="margin: 0 6px;">
              <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
              ">
              <svg class="icon"  style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:${item.color};"/></svg>
              </span>
              <span>${item.seriesName}</span>
              <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
            </div>
          </div>`;
                });
                return dataStr;
              },
            },
            dataZoom: [
              {
                bottom: "20",
                right: "35",
                left: "60",
                height: "6",
                type: "slider", //图表下方的伸缩条
                show: true, //是否显示
                start: 0, //伸缩条开始位置（1-100），可以随时更改
                end: 100, //伸缩条结束位置（1-100），可以随时更改
                dataBackground: {
                  //未选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                selectedDataBackground: {
                  //选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                // textStyle:false,
                showDetail: false,
                height: "6",
                borderColor: "#383848", //缩放条边框颜色
                fillerColor: "#383848", //选中的阴影填充背景颜色
                handleSize: "14",
                handleStyle: {
                  color: "#48485A",
                  borderWidth: "0", //去除缩放手柄描边
                },
                // 自定义缩放手柄图标
                handleIcon:
                  "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z",
                moveHandleSize: "0", //拖拽手柄尺寸大小
                moveHandleStyle: {
                  borderMiterLimit: 10,
                },
              },
            ],
            xAxis: {
              type: "category",
              data: this.DynamicData.xData,
              axisTick: {
                show: false,
              },
              axisLabel: {
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  type: [10, 10],
                  color: "#46494A",
                  width: 1,
                },
              },
            },
            series: this.DynamicData.series,
          };
          if (showBol) {
            option.dataZoom[0].maxValueSpan = 3; //区域内最多片段数据显示量
            option.dataZoom[0].zoomLock = true; //固定只能拖动不能缩放
            option.dataZoom[0].brushSelect = false; //禁用十字拖拽
          }
          let myChart = $echarts.init(this.$refs[ref]);
          if (showBol) {
            this.showChart.chartDom = myChart;
            this.closeFormatter(option);
          }
          this.DynamicData.ElDom = myChart;
          myChart.setOption(option);
        });
    },
    // 一造次所有玫瑰图初始化
    getAllCakeChartsInit() {
      this.isDown = false;
      this.OneCakeChartData.ElDom && this.OneCakeChartData.ElDom.dispose();
      this.TwoCakeChartData.ElDom && this.TwoCakeChartData.ElDom.dispose();
      this.ThreeCakeChartData.ElDom && this.ThreeCakeChartData.ElDom.dispose();
      service
        .getForTargetValueByPieChart({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "fish",
        })
        .then((res) => {
          if (Object.keys(res.data).length) {
            let [one, two, three] = [0, 0, 0];
            this.OneCakeChartData.series = res.data.saleMoney.slice(0, 3);
            this.TwoCakeChartData.series = res.data.harvestYield.slice(0, 3);
            this.ThreeCakeChartData.series = res.data.harvestArea.slice(0, 3);
            this.OneCakeChartData.otherData = res.data.saleMoney.slice(3);
            this.TwoCakeChartData.otherData = res.data.harvestYield.slice(3);
            this.ThreeCakeChartData.otherData = res.data.harvestArea.slice(3);
            res.data.saleMoney.forEach((item, idx) => {
              if (idx > 2) {
                one += item.value;
              }
            });
            one > 0 &&
              this.OneCakeChartData.series.push({
                name: "其他",
                value: one.toFixed(4),
              });
            res.data.harvestYield.forEach((item, idx) => {
              if (idx > 2) {
                two += item.value;
              }
            });
            two > 0 &&
              this.TwoCakeChartData.series.push({
                name: "其他",
                value: two.toFixed(4),
              });
            res.data.harvestArea.forEach((item, idx) => {
              if (idx > 2) {
                three += item.value;
              }
            });
            three > 0 &&
              this.ThreeCakeChartData.series.push({
                name: "其他",
                value: three.toFixed(4),
              });
            this.outputValueChartsInit("outputValueCharts");
            this.outputValueChartsInit2("outputAmountCharts");
            this.outputValueChartsInit3("areaCharts");
          }
        })
        .catch((err) => console.log(err));
    },
    // 一造次各品种投卵情况table初始化
    getTableOneDataInit() {
      service
        .searchMdtHarvestAnalysisOrgByPutNumList({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "fish",
        })
        .then((res) => {
          this.tableOneData = res.data;
        })
        .catch((err) => console.log(err));
    },
    // 一造次饲料使用情况table初始化
    getTableTwoDataInit() {
      service
        .searchMdtHarvestAnalysisOrgByUseFodderList({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "fish",
        })
        .then((res) => {
          let num = 0;
          if (res.data["fodderTypeData"]) {
            res.data["fodderTypeData"].forEach((item) => {
              num = Page.numAdd(num, item.fodderWeight);
            });
          }
          this.tableTwoData.OneTableData = res.data.fodderTypeData;
          this.tableTwoData.TwoTableData = res.data.fodderWeightData;
          this.feedUseNum = num;
        })
        .catch((err) => console.log(err));
    },
    // 获取一造次各品种销售产值、收获产量、收获面积
    getForTargetValueByPieNum() {
      service
        .getOrgForTargetValue({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "fish",
        })
        .then((res) => {
          if (res.code == "0000") {
            this.carouselData = res.data;
          }
          // 一造次销售产值
          this.outputValueData.saleMoney = res.data.saleMoney;
          this.outputValueData.saleMoneyLast = res.data.saleMoneyLast;
          this.outputValueData.saleMoneyPerCent = res.data.saleMoneyPerCent;
          // 一造次收获总产量
          this.yieldData.harvestYield = res.data.harvestYield;
          this.yieldData.harvestYieldLast = res.data.harvestYieldLast;
          this.yieldData.harvestYieldPerCent = res.data.harvestYieldPerCent;
          // 一造次收获总面积
          this.areaData.harvestArea = res.data.harvestArea;
          this.areaData.harvestAreaLast = res.data.harvestAreaLast;
          this.areaData.harvestAreaPerCent = res.data.harvestAreaPerCent;
          // 给造次名称赋值
          this.periodName = res.data.periodName || "一造次";
        })
        .catch((err) => console.log(err));
    },
    clearScrollFeed() {
      clearInterval(this.scrollFeedInterval);
    },
    setScrollFeed() {
      this.scrollFeedInterval = setInterval(this.scrollDownFeed, 5460);
    },
    scrollDownFeed() {
      // 拿到表格中承载数据的div元素q
      const divData = this.$refs.tableContent;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      const timeTop = setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1;
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          clearInterval(timeTop);
          setTimeout(() => {
            divData.scrollTop = 0;
          }, 5460);
        }
        if (divData.scrollTop % 46 === 0) {
          clearInterval(timeTop);
        }
      }, 10); // 滚动速度
    },
    tableScroll() {
      const table = this.$refs.breedTable;
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      const timeTop = setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1;
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          clearInterval(timeTop);
          setTimeout(() => {
            divData.scrollTop = 0;
          }, 5690);
        }
        if (divData.scrollTop % 69 === 0) {
          clearInterval(timeTop);
        }
      }, 10); // 滚动速度
    },
    clearBreedScroll() {
      clearInterval(this.breedTableTimer);
    },
    setBreedScroll() {
      this.breedTableTimer = setInterval(this.tableScroll, 5690);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.breedTableTimer = setInterval(this.tableScroll, 5690);
      this.scrollFeedInterval = setInterval(this.scrollDownFeed, 5460);
    });
    let reg2 = new RegExp(/^\d{4}\-\d{2}\-\d{2}$/);
    // 正则验证 当时间格式为yyyy-MM-DD时才会初始化图表
    if (!reg2.test(this.date)) {
      return;
    }
    // 获取一造次各品种销售产值、收获产量、收获面积
    this.getForTargetValueByPieNum();
    // 一造次饲料使用情况table初始化
    this.getTableTwoDataInit();
    // 一造次各品种投卵情况table初始化
    this.getTableOneDataInit();
    // 一造次各品种育苗天数与投入成本charts初始化
    this.dateCostChartsInit("rashDateCostCharts");
    // 一造次各品种收获塘口数柱状图
    this.tangkouChartsInit2("tangkouCharts");
    // 初始化页面所有饼状图
    this.getAllCakeChartsInit();
    // 饲料现存量|动保现存量 charts初始化
    this.ChartsCheckoutTarget(this.feedAndDongbaoTarget);
    // 饲料日投喂charts初始化
    this.PrivateChatChartsInit("DailyFeedCharts");
    // 动保日投用charts初始化
    this.PrivateChatChartsInit2("PrivateChatCharts");
    // 日死鱼情况折线图
    this.SunDeadFishChartsInit("dayDynamicProtectionCharts");
    // 各区域各品种死鱼情况
    this.SaveDynamicProtectionChartsInit("SaveDynamicProtectionCharts");
  },
  beforeDestroy() {
    clearInterval(this.WarningTimer);
    clearInterval(this.scrollFeedInterval);
    clearInterval(this.breedTableTimer);
  },
  created() {
    // 获取是否公斤转换成斤
    listParamStatus(this.orgId, ['fodderKgToJin']).then((res) => {
      if (res.code == "0000") {
        this.fodderKgToJin = res.data.fodderKgToJin === true ? '斤' : '公斤';
      }
    })
    this.resizeHandler = debounce(
      () => {
        console.log(1);
      },
      100,
      false
    );
    // 监听浏览器窗口页面
    window.addEventListener("resize", this.resizeHandler);
  },
  // 数据监听
  watch: {
    date: function (value, old) {
      let reg2 = new RegExp(/^\d{4}\-\d{2}\-\d{2}$/);
      // 正则验证 当时间格式为yyyy-MM-DD时才会初始化图表
      if (!reg2.test(value)) {
        return;
      }
      this.feedDefaultNum = null;
      this.OneCakeChartData.other = false;
      this.TwoCakeChartData.other = false;
      this.ThreeCakeChartData.other = false;
      // 一造次各品种销售产值、收获产量、收获面积
      this.getForTargetValueByPieNum();
      // 一造次饲料使用情况table初始化
      this.getTableTwoDataInit();
      // 一造次各品种投卵情况table初始化
      this.getTableOneDataInit();
      // 一造次各品种育苗天数与投入成本charts初始化
      this.dateCostChartsInit("rashDateCostCharts");
      // 一造次各品种销售产值、收获产量、收获面积charts初始化
      this.getAllCakeChartsInit();
      // 饲料现存量以及动保现存量chart初始化
      this.ChartsCheckoutTarget(this.feedAndDongbaoTarget);
      // 饲料日投喂charts初始化
      this.PrivateChatChartsInit("DailyFeedCharts");
      // 动保日投用charts初始化
      this.PrivateChatChartsInit2("PrivateChatCharts");
      // 日死鱼情况折线图
      this.SunDeadFishChartsInit("dayDynamicProtectionCharts");
      // 各区域各品种死鱼情况
      this.SaveDynamicProtectionChartsInit("SaveDynamicProtectionCharts");
      // 一造次各品种收获塘口数柱状图
      this.tangkouChartsInit2("tangkouCharts");
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  width: 100%;
  min-height: 939px;
  // height: 100%;
  // height: auto;
  overflow-y: auto;
  display: flex;
  background: #181a1f;
  // 布局样式
  > div {
    // 去除左右两边外间距和盒子的外间距
    width: calc((100% - 21px) / 2);
    margin-top: 7px;
    margin-left: 7px;
  }
  .left-box {
    flex-direction: column;
    box-sizing: border-box;
    display: flex;

    .top-box {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      height: 136px;
      .el-carousel {
        width: 100%;
        padding: 0;
        /deep/ .el-carousel__container {
          .el-carousel__arrow--left {
            left: 0;
          }
          .el-carousel__arrow--right {
            right: 0;
          }
          .el-carousel__item {
            display: flex;
            justify-content: space-between;
            > div {
              box-sizing: border-box;
              width: calc((100% - 14px) / 3);
              background: #5442ff;
              font-size: 20px;
              padding: 13px 0px 13px 0px;
              > div {
                align-items: center;
                display: flex;
                height: 100%;

                .text {
                  flex-direction: column;
                  display: flex;
                  width: 59%;
                  text-align: center;
                  font-size: 14px;
                  height: 100%;
                  font-family: DINCond-Black;
                  font-weight: 400;

                  p:nth-child(1) {
                    margin-top: 6px;
                    height: 25px;
                    display: inline-block;

                    img {
                      height: 100%;
                    }
                  }

                  p:nth-child(2) {
                    display: inline-block;

                    span {
                      margin-top: 1px;
                    }
                  }

                  p:nth-child(3) {
                    margin-top: 3px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    font-size: 12px;
                    color: #ffffff;
                  }
                }

                .num-text {
                  box-sizing: border-box;
                  border-left: 2px solid #432ffc;
                  flex: 1;
                  width: 41%;
                  height: 100%;
                  font-size: 13px;
                  display: flex;
                  flex-direction: column;
                  color: #fbfbff;
                  font-family: DINCond-Black;
                  font-weight: 400;

                  div:nth-child(1) {
                    width: 100%;
                    display: inline-block;
                    height: 50%;

                    p:nth-child(1) {
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      text-align: center;
                    }

                    p:nth-child(2) {
                      text-align: center;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      span:first-child {
                        font-size: 24px;
                      }

                      span:last-child {
                        position: relative;
                        display: inline-block;

                        img {
                          top: -20px;
                          position: absolute;
                        }
                      }
                    }
                  }

                  div:nth-child(2) {
                    margin-top: 16px;
                    width: 100%;
                    display: inline-block;
                    height: 50%;

                    p:nth-child(1) {
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      text-align: center;
                    }

                    p:nth-child(2) {
                      text-align: center;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      span:first-child {
                        font-size: 24px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .center-box {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      height: 384px;
      margin-top: 7px;
      > div {
        width: calc((100% - 20px) / 3);
        display: flex;
        flex-direction: column;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;

        div:first-child {
          margin-top: 22px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }
        }

        .down-box {
          box-sizing: border-box;
          width: 120px;
          height: 10px;
          position: absolute;
          z-index: 2000;
          top: 136px;
          left: 25px;
          pointer-events: none;
          line-height: 10px;
          color: #d0cccc;
          padding-left: 95px;
        }
        div:last-child {
          padding-top: 20px;
          width: 100%;
          height: 100%;
          // background: pink;
        }

        .other {
          bottom: 8px;
          position: absolute;
          height: 220px !important;
          background: #1e1e2b;
          padding: 0 !important;
          padding-left: 49px !important;
          box-sizing: border-box;
          overflow: auto;
          &::-webkit-scrollbar {
            //滚动条整体的宽度
            width: 6px;
            height: 6px;
          }

          &::-webkit-scrollbar-thumb {
            //滚动条小点的设置
            background-color: #48485a;
            background-clip: padding-box;
            min-height: 28px;
            border-radius: 8px;
          }
          > div {
            margin: 0;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d0cccc;
            padding: 0;
            width: 100%;
            height: auto;
            padding: 3px 0 3px 0;
            box-sizing: border-box;
          }
        }
      }
    }

    .bottom-box {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      height: 391px;
      margin-top: 7px;
      > div {
        width: calc((100% - 20px) / 3);
        display: flex;
        flex-direction: column;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;

        div:first-child {
          margin-top: 16px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }
        }

        div:last-child {
          padding-top: 20px;
          width: 100%;
          height: 100%;
        }

        /deep/.table-box {
          ::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }
          ::-webkit-scrollbar-corner {
            display: none;
          }
          overflow-y: hidden;
          width: 100%;
          height: 100%;
          // el-table样式改变
          .el-table {
            ::-webkit-scrollbar {
              display: unset; /* Chrome Safari */
            }
            padding: 0;
            width: 100%;
            overflow: scroll;
            margin-top: unset;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            background: #1e1e2b;
            border-color: #46494a;
          }

          .el-table__cell.gutter {
            display: none;
          }

          ::-webkit-scrollbar-track-piece {
            //滚动条凹槽的颜色，还可以设置边框属性
            //滚动条剩余部分的背景颜色
            background-color: #1e1e2b;
          }

          ::-webkit-scrollbar {
            //滚动条整体的宽度
            width: 6px;
            height: 6px;
          }

          ::-webkit-scrollbar-thumb {
            //滚动条小点的设置
            background-color: #48485a;
            background-clip: padding-box;
            min-height: 28px;
            border-radius: 8px;
          }

          // 滚动条的宽度
          /deep/ .el-table__body-wrapper::-webkit-scrollbar {
            width: 2px; // 横向滚动条
            height: 2px; // 纵向滚动条 必写
          }
          // 滚动条的滑块
          /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
            background-color: #ddd;
            border-radius: 3px;
          }

          .el-table__header {
            color: red;
          }

          .el-table::before {
            display: none;
            // background: #46494a;
          }

          .el-table td.el-table__cell {
            border-color: #46494a;
          }

          .el-table .el-table__cell {
            padding: 11px 0px !important;
          }

          .el-table .cell {
            text-align: center;
          }

          .el-table th.el-table__cell > .cell {
            overflow: unset;
            // white-space: nowrap;
          }

          .el-table tbody tr:hover > td {
            background: #1e1e2b !important;
          }

          .el-table tr {
            background: #1e1e2b;
          }

          .table-one-box {
            display: flex;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            padding: 0px 10px 20px 0px;
            .el-table {
              padding-right: 10px;
              .el-table__body-wrapper {
                padding-right: 10px !important;
              }
            }
          }
        }
      }

      .bottom-center-box {
        position: relative;
        > div:first-child {
          display: flex;
          > span:nth-child(1) {
            margin-top: 2px;
          }
          > span:nth-child(2) {
            display: inline-block;
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
            width: 185px;
          }
        }
        /deep/.check {
          white-space: nowrap;
          cursor: pointer;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #d7d7d9;

          .route-target {
            display: inline-block;
            margin-left: 20px;
            margin-top: unset;
            padding-top: unset;
            width: unset;
            height: unset;

            .check {
              background: unset;
            }
          }

          i {
            font-size: 13px;
          }
        }
      }
    }
  }
  .right-box {
    flex-direction: column;
    box-sizing: border-box;
    display: flex;

    > div {
      margin-top: 7px;
      // 去除左右两边外间距和盒子的外间距
      width: 100%;
      height: 303.67px;

      &:first-child {
        margin-top: 0;
      }
    }

    .top-box {
      display: flex;
      > div {
        // display: flex;
        // flex-direction: column;
        // // 去除左右两边外间距和盒子的外间距
        // width: calc(100% / 2 - 8px);
        // margin-right: 16px;
        // background: #1e1e2b;
        // border: 1px solid #2e2d3e;
        display: flex;
        flex-direction: column;
        // 去除左右两边外间距和盒子的外间距
        width: calc(100% / 2);
        margin-right: 7px;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;

        &:last-child {
          margin-right: unset;
        }

        div:first-child {
          margin-top: 16px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }
        }
        .table-content {
          overflow-y: scroll;
          box-sizing: border-box;
          height: 230px;
          &::-webkit-scrollbar {
            width: 6px;
          }
          &::-webkit-scrollbar-thumb {
            //滚动条小点的设置
            background-color: #48485a;
            background-clip: padding-box;
            min-height: 28px;
            border-radius: 8px;
          }
          /deep/.table-box {
            &::-webkit-scrollbar {
              display: none; /* Chrome Safari */
            }
            transition: all 0.5s;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            width: 100%;

            // el-table样式改变
            .el-table {
              margin-top: 0;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              background: #1e1e2b;
              border-color: #46494a;
            }

            .el-table__cell.gutter {
              display: none;
            }

            ::-webkit-scrollbar-track-piece {
              //滚动条凹槽的颜色，还可以设置边框属性
              //滚动条剩余部分的背景颜色
              background-color: #1e1e2b;
            }

            ::-webkit-scrollbar {
              //滚动条整体的宽度
              width: 6px;
              height: 6px;
            }

            ::-webkit-scrollbar-thumb {
              //滚动条小点的设置
              background-color: #48485a;
              background-clip: padding-box;
              min-height: 28px;
              border-radius: 8px;
            }

            // 滚动条的宽度
            /deep/ .el-table__body-wrapper::-webkit-scrollbar {
              width: 2px; // 横向滚动条
              height: 2px; // 纵向滚动条 必写
            }
            // 滚动条的滑块
            /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
              background-color: #ddd;
              border-radius: 3px;
            }

            .el-table__header {
              color: red;
            }

            .el-table::before {
              display: none;
              // background: #46494a;
            }

            .el-table td.el-table__cell {
              border-color: #46494a;
            }

            .el-table .el-table__cell {
              padding: 11px 0px !important;
            }

            .el-table .cell {
              text-align: center;
            }

            .el-table th.el-table__cell > .cell {
              overflow: unset;
              white-space: nowrap;
            }

            .el-table tbody tr:hover > td {
              background: #1e1e2b !important;
            }

            .el-table tr {
              background: #1e1e2b;
            }

            .table-one-box {
              display: flex;
              box-sizing: border-box;
              width: 100%;
              height: 100%;
              padding: 0px 10px 20px 0px;
            }

            .table-two-box {
              box-sizing: border-box;
              padding-right: 19px;
              display: flex;
              width: 100%;
            }
          }
        }
      }
    }

    .center-box {
      display: flex;
      > div {
        display: flex;
        flex-direction: column;
        // 去除左右两边外间距和盒子的外间距
        width: calc(100% / 2);
        margin-right: 7px;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;

        &:last-child {
          margin-right: unset;
        }

        div:first-child {
          position: relative;
          margin-top: 22px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #afaeae;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }

          .success {
            color: #ffffff;
          }

          /deep/.check {
            white-space: nowrap;
            cursor: pointer;
            position: absolute;
            right: 23px;
            bottom: 3px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d7d7d9;

            .route-target {
              margin-bottom: -3px;
              margin-right: 23px;
              width: unset;

              .check {
                background: unset;
              }
            }

            i {
              font-size: 13px;
            }
          }
        }

        div:last-child {
          padding-top: 20px;
          width: 100%;
          height: 100%;
        }
      }
    }

    .bottom-box {
      display: flex;
      > div {
        display: flex;
        flex-direction: column;
        // 去除左右两边外间距和盒子的外间距
        width: calc(100% / 2);
        margin-right: 7px;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;

        &:last-child {
          margin-right: unset;
        }

        div:first-child {
          position: relative;
          margin-top: 22px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }

          /deep/.swiper-warning-box {
            position: absolute;
            right: 23px;
            bottom: -5px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            width: 183px;
            height: 40px;
            background: rgba(245, 83, 251, 0.18);

            ::-webkit-scrollbar {
              //滚动条整体的宽度
              width: 6px;
              height: 6px;
              display: none;
            }

            .waring-ul {
              width: 183px;
              height: 40px;
              color: white;
              overflow-y: hidden;
              overflow-x: hidden;
              font-size: 13px;

              .waring-li {
                width: 183px;
                height: 40px;
                display: flex;
                overflow: hidden;
                border: 1px solid #46494a;
                border-top: unset;
                border-left: unset;

                &:last-child {
                  border-bottom: unset;
                }

                .i1 {
                  text-align: center;
                  box-sizing: border-box;
                  padding-top: 10px;
                  width: 61px;
                  height: 100%;
                }

                .i2 {
                  flex: 1;
                  padding-right: 9px;
                  padding-top: 3px;
                  display: -webkit-box;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
            }
          }
        }

        div:last-child {
          padding-top: 20px;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>